<template>
  <main class="residency-inputs" :style="`grid-template-columns: repeat(${columns}, 1fr);`">
    <ApfBasicInput :name="fields.status" :validator="validator" label="Residency Status when in Bhutan">
      <select class="form-control" v-model="form[fields.status]" @change="$emit('onResidencyChange')">
        <option value="" disabled>Please select</option>
        <option v-for="opt of getResidencyOptions()" :value="opt.value" :key="opt.value">{{ opt.label }}</option>
      </select>
    </ApfBasicInput>

    <ApfBasicInput :name="fields.expiry" :validator="validator" v-if="showExpiryDateInput" label="Expiry Date">
      <el-date-picker
        type="date"
        v-model="form[fields.expiry]"
        format="dd/MM/yyyy"
        value-format="dd/MM/yyyy"
        placeholder="Pick a day"
      />
    </ApfBasicInput>
  </main>
</template>

<script>
import ApfBasicInput from '@/pages/application/components/ApfBasicInput'
import { constApfEBISResidency, ebisResidencyNoExpiryStatuses } from '@/pages/application/const/applicationConst'

export default {
  props: ['columns', 'form', 'fields', 'validator', 'type'],
  components: { ApfBasicInput },
  computed: {
    showExpiryDateInput() {
      const status = this.form[this.fields.status]
      return status && !ebisResidencyNoExpiryStatuses.includes(status)
    },
  },
  methods: {
    getResidencyOptions() {
      return this.type === 'child' ? constApfEBISResidency.child : constApfEBISResidency.parent
    },
  },
}
</script>

<style scoped>
.residency-inputs {
  display: grid;
  column-gap: 3rem;
  row-gap: 1.5rem;
}
</style>
